module.exports = __webpack_public_path__ + "static/photos-coming-soon-67678095067ac784f81725cde2cdd3bf.jpg";